import { useState } from 'react';

const STATUS_COLORS = { online: '#10b981', away: '#f59e0b', dnd: '#f43f5e' };

// status: 'online' | 'away' | 'dnd' | 'offline' | undefined (no dot)
export default function Avatar({ src, size = 44, border = '1.5px solid var(--purple-dim)', status }) {
  const circle = <AvatarCircle src={src} size={size} border={border} />;
  if (!STATUS_COLORS[status]) return circle;
  const dot = Math.max(Math.round(size * 0.3), 9);
  return (
    <div style={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
      {circle}
      <span
        title={status === 'dnd' ? 'Do not disturb' : status === 'away' ? 'Away' : 'Online'}
        style={{
          position: 'absolute', right: -1, bottom: -1, width: dot, height: dot, borderRadius: '50%',
          background: STATUS_COLORS[status], border: '2px solid var(--black)', boxSizing: 'border-box',
        }}
      />
    </div>
  );
}

function AvatarCircle({ src, size, border }) {
  const [loaded, setLoaded] = useState(false);
  const spinnerSize = Math.max(Math.round(size * 0.35), 10);
  return (
    <div style={{
      width: size, height: size, borderRadius: '50%', flexShrink: 0,
      backgroundColor: 'var(--surface3)',
      border,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: size * 0.45, overflow: 'hidden',
      position: 'relative',
    }}>
      {!src && '👤'}
      {src && !loaded && (
        <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{
            width: spinnerSize, height: spinnerSize,
            border: '2px solid var(--border)',
            borderTopColor: 'var(--purple)',
            borderRadius: '50%',
            animation: 'spin 0.7s linear infinite',
          }} />
        </div>
      )}
      {src && (
        <img
          src={src}
          alt=""
          onLoad={() => setLoaded(true)}
          style={{
            width: '100%', height: '100%',
            objectFit: 'cover',
            opacity: loaded ? 1 : 0,
            transition: 'opacity 0.18s ease',
          }}
        />
      )}
    </div>
  );
}
